import React from 'react';
import classes from './NavigationItem.module.scss';

import {connect} from "react-redux";

const navigationItem = ( props ) => {

    let addClasses = [];

    let QuestionsData = require( '../../../data/' + props.mode + '-questions.js' );


    if( props.complete ) {
        addClasses.push( classes['BG-' + QuestionsData[ props.version ][ props.current ].color_scheme ] );
    }

    if( props.active ) {
        addClasses.push( classes['BG-' + QuestionsData[ props.version ][ props.current ].color_scheme ] );
    }

    const onItemClick = ( props.complete ) ? () => props.onItemClick( props.index ) : () => {};

    return (
        <div className={[classes.NavigationItem,...addClasses].join(' ')}
             onClick={onItemClick}
        >&nbsp;</div>
    );

};

const mapStateToProps = state => {
    return {
        mode: state.mode
    }
};

export default connect( mapStateToProps )( navigationItem );
